var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.352,
    height: 39.734,
    viewBox: "0 0 59.352 39.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 59.352,
    height: 39.734,
    fill: "#363636"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(-254.242 -709.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(254.242 709.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M97.064,116.476H64.4L68.61,96.818h4.622v2.366c-.729,0-1.474.011-2.219,0-.328-.007-.468.1-.54.44q-1.5,7.079-3.02,14.153c-.016.073-.025.148-.048.288H94.069c-.279-1.328-.548-2.625-.825-3.92-.725-3.4-1.471-6.789-2.165-10.192-.127-.622-.366-.835-.989-.776s-1.227.012-1.875.012V96.809h4.633l4.216,19.667",
    transform: "translate(-51.084 -76.797)",
    fill: "#363636"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ON",
    transform: "translate(20.676 32.933)",
    fill: "#363636",
    fontSize: 11,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ON"))), /*#__PURE__*/React.createElement("path", {
    id: "globe-solid",
    d: "M14.7,10.689a26.109,26.109,0,0,1-.138,2.672H6.819a25.875,25.875,0,0,1-.175-2.672,25.875,25.875,0,0,1,.175-2.672H14.56A26.109,26.109,0,0,1,14.7,10.689ZM21.04,8.017a10.726,10.726,0,0,1,0,5.345H15.9c.088-.86.134-1.791.134-2.672A26.381,26.381,0,0,0,15.9,8.017ZM20.6,6.681H15.729A14.682,14.682,0,0,0,13.42.352,10.713,10.713,0,0,1,20.6,6.681Zm-6.226,0H7A16.769,16.769,0,0,1,8.13,2.729,6.826,6.826,0,0,1,9.528.577,1.72,1.72,0,0,1,10.689,0,1.72,1.72,0,0,1,11.85.577a6.826,6.826,0,0,1,1.4,2.152,16.769,16.769,0,0,1,1.127,3.952Zm-13.6,0A10.711,10.711,0,0,1,7.958.352,14.682,14.682,0,0,0,5.649,6.681Zm4.7,1.336a26.207,26.207,0,0,0-.171,2.672c0,.881.084,1.812.171,2.672H.337a10.771,10.771,0,0,1,0-5.345ZM8.13,18.648A16.733,16.733,0,0,1,7,14.7h7.374a16.733,16.733,0,0,1-1.127,3.95,6.8,6.8,0,0,1-1.4,2.155,1.728,1.728,0,0,1-1.2.576A1.73,1.73,0,0,1,9.528,20.8a6.8,6.8,0,0,1-1.4-2.155Zm-.171,2.38A10.714,10.714,0,0,1,.777,14.7H5.649a14.687,14.687,0,0,0,2.309,6.33Zm5.462,0a14.687,14.687,0,0,0,2.309-6.33H20.6a10.717,10.717,0,0,1-7.182,6.33Z",
    transform: "translate(273.228 709.721)",
    fill: "#363636"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2d.0b5267fc920a5d786c06e269d1d901ec.svg";
export { ForwardRef as ReactComponent };